import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getResidueIntakeList as getResidueIntakeListApi,
	getResidueInboundFeed as getResidueInboundFeedApi,
	getResidueMovementsFeed as getResidueMovementsFeedApi,
	getResidueIntake as getResidueIntakeApi,
	addNewResidueIntake as addNewResidueIntakeApi,
	updateResidueIntake as updateResidueIntakeApi,
	deleteResidueIntake as deleteResidueIntakeApi,
} from '../../helpers/residue/backend_helper';

export const getResidueIntakeList = createAsyncThunk(
	'residueIntakes/getResidueIntakeList',
	async params => {
		try {
			const response = await getResidueIntakeListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

/** Respuesta esperada: `{ data, meta: { totalCount } }`. */
export const getResidueInboundFeed = createAsyncThunk(
	'residueIntakes/getResidueInboundFeed',
	async params => {
		try {
			return await getResidueInboundFeedApi(params);
		} catch (error) {
			throw new Error(
				error?.message || error || 'Error al cargar el listado de ingresos.',
			);
		}
	},
);

export const getResidueMovementsFeed = createAsyncThunk(
	'residueIntakes/getResidueMovementsFeed',
	async params => {
		try {
			return await getResidueMovementsFeedApi(params);
		} catch (error) {
			throw new Error(
				error?.message || error || 'Error al cargar movimientos RESPEL.',
			);
		}
	},
);

export const getResidueIntake = createAsyncThunk(
	'residueIntakes/getResidueIntake',
	async residueIntakeId => {
		try {
			const response = await getResidueIntakeApi(residueIntakeId);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewResidueIntake = createAsyncThunk(
	'residueIntakes/addNewResidueIntake',
	async (residueIntake, { rejectWithValue }) => {
		try {
			const response = await addNewResidueIntakeApi(residueIntake);
			toast.success('Ingreso RESPEL registrado exitosamente.', { autoClose: 3000 });
			return response;
		} catch (error) {
			const status = error?.status || error?.response?.status;
			const message =
				error?.response?.data?.detail ||
				error?.response?.data?.message ||
				error?.message ||
				'Error al registrar ingreso RESPEL.';
			toast.error(
				status === 400
					? `No se pudo registrar el ingreso: ${message}`
					: 'Error al registrar ingreso RESPEL.',
				{ autoClose: 4000 }
			);
			return rejectWithValue({ status, message });
		}
	}
);

export const updateResidueIntake = createAsyncThunk(
	'residueIntakes/updateResidueIntake',
	async (residueIntake, { rejectWithValue }) => {
		try {
			const response = await updateResidueIntakeApi(residueIntake);
			toast.success('Ingreso RESPEL actualizado exitosamente.', { autoClose: 3000 });
			return response;
		} catch (error) {
			const status = error?.status || error?.response?.status;
			const message =
				error?.response?.data?.detail ||
				error?.response?.data?.message ||
				error?.message ||
				'Error al actualizar ingreso RESPEL.';
			// 409 == intake ya tiene consumo posterior (D-011)
			if (status === 409) {
				toast.error(
					'No se puede editar: este ingreso ya tiene movimientos de salida posteriores.',
					{ autoClose: 5000 }
				);
			} else {
				toast.error(
					status === 400
						? `No se pudo actualizar: ${message}`
						: 'Error al actualizar ingreso RESPEL.',
					{ autoClose: 4000 }
				);
			}
			return rejectWithValue({ status, message });
		}
	}
);

export const deleteResidueIntake = createAsyncThunk(
	'residueIntakes/deleteResidueIntake',
	async (residueIntake, { rejectWithValue }) => {
		try {
			const response = await deleteResidueIntakeApi(residueIntake);
			toast.success('Ingreso RESPEL eliminado exitosamente.', { autoClose: 3000 });
			return { ...residueIntake, ...response };
		} catch (error) {
			const status = error?.status || error?.response?.status;
			const message =
				error?.response?.data?.detail ||
				error?.response?.data?.message ||
				error?.message ||
				'Error al eliminar ingreso RESPEL.';
			if (status === 409) {
				toast.error(
					'No se puede eliminar: este ingreso ya tiene movimientos de salida posteriores.',
					{ autoClose: 5000 }
				);
			} else {
				toast.error('Error al eliminar ingreso RESPEL.', { autoClose: 3000 });
			}
			return rejectWithValue({ status, message });
		}
	}
);
